<template>
  <div class="nota">
    <div v-if="loading" class="nota-state">Menyiapkan nota...</div>
    <div v-else-if="error" class="nota-state">{{ error }}</div>

    <div v-else align="center" class="nota-body">
      <b style="font-size: 1.4em">{{ shift.store?.storeName }}</b>
      <br />
      {{ shift.store?.address }}
      <div>
        <table width="100%">
          <tr>
            <td colspan="2"><hr /></td>
          </tr>
          <tr>
            <td colspan="2" align="center"><b>SHIFT PRINT</b></td>
          </tr>
          <tr>
            <td colspan="2"><hr /></td>
          </tr>
          <tr>
            <td valign="top">Kasir</td>
            <td align="right" valign="top">{{ shift.cashier?.label }}</td>
          </tr>
          <tr>
            <td valign="top">Starting Shift</td>
            <td align="right" valign="top">
              {{ dateTimeFormat(shift.startDate, "DD/MM/yyyy HH:mm") }}
            </td>
          </tr>
          <tr>
            <td valign="top">Ending Shift</td>
            <td align="right" valign="top">
              {{ dateTimeFormat(shift.endDate, "DD/MM/yyyy HH:mm") }}
            </td>
          </tr>
          <tr>
            <td valign="top">Sold Items</td>
            <td align="right" valign="top">{{ shift.soldItems }}</td>
          </tr>
          <tr>
            <td valign="top">Expense Items</td>
            <td align="right" valign="top">{{ shift.expenseItems }}</td>
          </tr>
          <tr>
            <td colspan="2"><hr /></td>
          </tr>
        </table>
      </div>

      <div v-if="shift.solds?.length > 0">
        <table width="100%">
          <tbody>
            <tr style="height: 25px">
              <td valign="top" colspan="2"><b>SOLD ITEMS</b></td>
            </tr>
          </tbody>
          <tbody v-for="(row, i) in shift.solds" v-bind:key="`sold-${i}`">
            <tr>
              <td valign="top">
                {{ row.product?.label }} {{ row.productVariantName }}
              </td>
              <td align="right" valign="bottom">
                <small v-if="row.discount > 0">
                  Diskon: {{ numberFormat(row.discount) }}
                </small>
              </td>
            </tr>
            <tr>
              <td valign="top">
                {{ row.quantity }} x {{ numberFormat(row.price) }}
              </td>
              <td align="right" valign="top">
                <!-- Laporan shift agregat lintas transaksi (VwCartSummaries): tak bisa
                     bedakan diskon transaksi vs item per baris, jadi tetap tampilkan
                     diskon per baris + Total Diskon di ringkasan. -->
                <small
                  v-if="row.discount > 0"
                  style="text-decoration: line-through"
                >
                  {{ numberFormat(row.total) }}
                </small>
                <b>{{ numberFormat(row.fixedPrice) }}</b>
              </td>
            </tr>
            <tr v-if="i != shift.solds.length - 1" style="height: 5px">
              <td colspan="2"></td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td colspan="2"><hr /></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="shift.expenses?.length > 0">
        <table width="100%">
          <tbody>
            <tr style="height: 25px">
              <td valign="top" colspan="2"><b>EXPENSE ITEMS</b></td>
            </tr>
          </tbody>
          <tbody v-for="(row, i) in shift.expenses" v-bind:key="`expense-${i}`">
            <tr>
              <td valign="top">{{ row.expense }}</td>
              <td align="right">
                <small>{{ row.expenseGroup?.label }}</small>
              </td>
            </tr>
            <tr>
              <td valign="top">
                {{ row.quantity }} x {{ numberFormat(row.amount) }}
              </td>
              <td align="right" valign="top">
                <b>{{ numberFormat(row.grandTotal) }}</b>
              </td>
            </tr>
            <tr v-if="i != shift.expenses.length - 1" style="height: 5px">
              <td colspan="2"></td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td colspan="2"><hr /></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="shift.paymentMethods?.length > 0">
        <table width="100%">
          <tbody>
            <tr style="height: 25px">
              <td valign="top" colspan="2"><b>PAYMENT DETAILS</b></td>
            </tr>
          </tbody>
          <tbody
            v-for="(row, i) in shift.paymentMethods"
            v-bind:key="`payment-${i}`"
          >
            <tr>
              <td valign="top">{{ row.paymentMethod?.label }}</td>
              <td align="right" valign="top">
                <b>{{ numberFormat(row.grandTotal) }}</b>
              </td>
            </tr>
            <tr v-if="i != shift.paymentMethods.length - 1" style="height: 5px">
              <td colspan="2"></td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td colspan="2"><hr /></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <table width="100%">
          <tr>
            <td valign="top">Sales</td>
            <td align="right" valign="top">
              <b v-if="shift.sales > 0">{{ numberFormat(shift.sales) }}</b>
              <span v-else>-</span>
            </td>
          </tr>
          <tr>
            <td valign="top">Outstanding</td>
            <td align="right" valign="top">
              <b v-if="shift.outstanding > 0">
                {{ numberFormat(shift.outstanding) }}
              </b>
              <span v-else>-</span>
            </td>
          </tr>
          <tr>
            <td valign="top">Expense</td>
            <td align="right" valign="top">
              <b v-if="shift.expense > 0">
                ({{ numberFormat(shift.expense) }})
              </b>
              <span v-else>-</span>
            </td>
          </tr>
          <tr>
            <td colspan="2"><hr /></td>
          </tr>
        </table>
      </div>

      <div>
        <table width="100%">
          <tr>
            <td valign="top">Total Diskon</td>
            <td align="right" valign="top">
              <b v-if="shift.discount > 0">
                {{ numberFormat(shift.discount) }}
              </b>
              <span v-else>-</span>
            </td>
          </tr>
          <tr>
            <td valign="top">Total Transaksi</td>
            <td align="right" valign="top">
              <b v-if="shift.grandTotal > 0">
                {{ numberFormat(shift.grandTotal) }}
              </b>
              <b v-else>({{ numberFormat(shift.grandTotal * -1) }})</b>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { dateTimeFormat, numberFormat, isNullOrEmpty } from "@/core/utils";

export default {
  data: () => ({
    loading: true,
    error: null,
    shift: {},
  }),
  created() {
    const self = this;
    self.getShift();
  },
  methods: {
    dateTimeFormat,
    numberFormat,
    getShift() {
      const self = this;
      const { storeId, cashierId, transactionDate } = self.$route.params;

      if (
        isNullOrEmpty(storeId) ||
        isNullOrEmpty(cashierId) ||
        isNullOrEmpty(transactionDate)
      ) {
        self.loading = false;
        self.error = "Data shift tidak ditemukan";

        return;
      }

      self.$store
        .dispatch("apis/get", {
          url: `/report/${storeId}/shift/${cashierId}/${transactionDate}`,
        })
        .then((response) => {
          if (response.error) {
            self.error = response.message;

            return;
          }

          self.shift = response.data;
        })
        .finally(() => {
          self.loading = false;

          if (self.error) return;

          // Nota harus selesai ter-render sebelum dialog print browser dibuka.
          self.$nextTick(() => {
            window.print();
            setTimeout(() => window.close(), 500);
          });
        });
    },
  },
};
</script>

<style scoped>
.nota {
  padding: 5px;
  margin-left: auto;
  margin-right: auto;
  max-width: 300px;
  font-family: Poppins, Helvetica, sans-serif;
  font-size: 12px;
  color: #000;
  background: #fff;
}

.nota table {
  font-size: 12px;
}

.nota-body {
  padding: 5px;
  max-width: 300px;
}

.nota-state {
  padding: 24px 0;
  text-align: center;
}
</style>

<!-- Override print global Metronic (@page a3 + body/container min-width 992px)
     yang membuat nota di-scale mengecil pada printer thermal 80mm. Blok ini
     sengaja TIDAK scoped supaya bisa menimpa @page, html, dan body. -->
<style media="print">
@page {
  size: 80mm auto;
  margin: 0;
}

html,
body {
  width: 80mm !important;
  min-width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  background: #fff !important;
}

body .nota,
body .nota-body {
  width: 80mm !important;
  max-width: 80mm !important;
  min-width: 0 !important;
  margin: 0 !important;
}
</style>
